import styled from "styled-components";

export const Anchor = styled.a`
  color: inherit;

  &:hover {
    color: inherit;
    text-decoration: underline solid;
  }
`;
